import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-image-preview",
  templateUrl: "./image-preview.component.html",
  styleUrls: ["./image-preview.component.css"],
})
export class ImagePreviewComponent implements OnInit {
  @Input("image") image: any = "";
  constructor(
    private activeModal: NgbActiveModal,
    public modalService: NgbModal
  ) {}

  ngOnInit() {}

  closeModalImagePreview() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/image-preview/image-preview.component.ts